// extracted by mini-css-extract-plugin
module.exports = {"richText":"styles_richText__3-gbY","secondary":"styles_secondary__3e39K"};